<template>
    <div class="honor-certificates">
        <h2>荣誉资质</h2>
        <p class="description">秉承华软多年的工匠精神，我们一直在努力</p>
        <ul>
            <li v-for="(certificate, index) in certificates" :key="index">
                <img :src="certificate.image" :alt="certificate.title" />
                <p>{{ certificate.title }}</p>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'HonorCertificates',
    data() {
        return {
            certificates: [
                { title: '高新技术企业证书', image: require("@/assets/home/rongYu1.png") },
                { title: 'AAA级信用企业证书', image: require("@/assets/home/rongYu2.png") },
                { title: '优秀创新型企业奖', image: require("@/assets/home/rongYu3.png") },
                { title: '安防四级证书', image: require("@/assets/home/rongYu4.png") },
                { title: '华软无人机证书2024', image: require("@/assets/home/rongYu5.png") },
                { title: '环境管理体系认证证书', image: require("@/assets/home/rongYu6.png") },

                { title: '信息安全管理体系认证证书', image: require("@/assets/home/rongYu7.png") },
                { title: '职业健康安全管理体系认证证书', image: require("@/assets/home/rongYu8.png") },
                { title: '质量管理体系认证证书', image: require("@/assets/home/rongYu9.png") },
                { title: '重合同守信用企业', image: require("@/assets/home/rongYu10.png") },
                { title: '低慢小目标认证证书', image: require("@/assets/home/rongYu11.png") },
                { title: '无人机集控协同服务', image: require("@/assets/home/rongYu12.png") },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.honor-certificates {
    text-align: left;
    padding: 80px 0px 80px;
    width: 1200px;
    margin: 0 auto;

    h2 {
        font-family: PingFang SC;
        font-size: 32PX;
        font-weight: bold;
        line-height: normal;
        letter-spacing: normal;
        color: #1E242A;
        margin-bottom: 20px;
    }

    .description {
        font-family: PingFang SC;
        font-size: 14PX;
        font-weight: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1E242A;
        opacity: 0.6;
        margin-bottom: 39px;
    }

    ul {
        list-style: none;
        padding: 0;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 32px;

        li {
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 4px;
            background: #FBFBFB;
            height: 240px;
            padding: 32px;

            img {
                // width: 212px;
                height: 140px;
                // height: auto;
                // border: 1px solid #ddd;
                border-radius: 5px;
                margin-bottom: 5px;
            }

            p {
                font-size: 14PX;
                color: #1E242A;
                padding-top: 16px;
            }
        }
    }
}
</style>
